import ApolloClient from 'apollo-boost';
import Auth from '../auth/Auth';

const uri = process.env.REACT_APP_GRAPHQL_SERVER_URI;

const client = new ApolloClient({
  uri,
  request: operation => {
    const accessToken = Auth.getAccessToken();
    if (accessToken) {
      operation.setContext({
        headers: {
          Admin: `Bearer ${accessToken}`,
        },
      });
    }
  },
  onError: error => {
    if (error.graphQLErrors && error.graphQLErrors.length) {
      const graphqlError = error.graphQLErrors[0];
      if (
        !graphqlError.path.includes('admin_authLogin') &&
        graphqlError.message.includes('Access denied')
      ) {
        Auth.clearSession();
      }
    } else {
      window.alert(
        `Ein unerwarteter Fehler ist aufgetreten. \nOperation: ${
          error.operation.operationName
        } \nNetzwerk Fehler: ${error.networkError}`
      );
    }
  },
});

export default client;



// WEBPACK FOOTER //
// ./src/graphql/client.js